import React, { useState, useEffect, useMemo } from 'react';
import './App.css'; // Import CSS file for styling
import { useNavigate } from 'react-router-dom';
import { PROKIRIKSI_OPTIONS, TABLE_OPTIONS, TABLE_TYPES_WITHOUT_CLEANED_AUG26 } from './constants';
import { Header, Footer } from './headerFooter';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import { getHost } from './config';
import FilterSidebar from './FilterSidebar';
import { initialSidebarOpen, collapseFilterSidebarOnMobile, joinFilterSummaryParts } from './filterSidebarUtils';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./custom.scss";



function RankingPersonalDetails() {
    const navigate = useNavigate();
    const token = localStorage.getItem('authToken');

    useEffect(() => {
        if (!token) {
            navigate('/', { replace: true });
        }
    }, [token, navigate]);
    // State variables to hold form data
    const [formData, setFormData] = useState({
        table_type: '',
        last_name: '',
        first_name: '',
        father_name: '',
        id_card_number: '',
        table_value: ''
    });

    // State variable to hold API results
    const [results, setResults] = useState(null);
    const [loading, setLoading] = useState(false); // New loading state
    const [sidebarOpen, setSidebarOpen] = useState(initialSidebarOpen);

    // Handler for form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            // Make POST request to your FastAPI endpoint
            const uppercaseData = {
                ...formData,
                last_name: formData.last_name,
                first_name: formData.first_name,
                father_name: formData.father_name,
                // id_card_number if you decide to enable it later
            };
            const url = `${getHost()}/api/personal-ranking`
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(uppercaseData)
            });

            const responseData = await response.json();
            // Update results state with response data
            setResults(responseData.results);
            collapseFilterSidebarOnMobile(setSidebarOpen);
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setLoading(false); // Always stop loading, even on error
        }
    };

    // Handler for form input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        
        setFormData(prev => { 
            let updated = { ...prev, [name]: value };

            if (name === "table_type" && value.includes("2025")) {
                updated.table_value = "initial"
            }

            if (name === "table_type" && TABLE_TYPES_WITHOUT_CLEANED_AUG26.includes(value) &&
                ["cleaned_aug26", "cleaned_sep26", "cleaned_oct26"].includes(updated.table_value)) {
                updated.table_value = "initial"
            }

            return updated;
        });
    };

    const handleLogout = () => {
        // Clear the authToken from localStorage
        localStorage.removeItem('authToken');

        // Redirect to the login page
        navigate('/', { replace: true });
    }
    
    const isFormValid = formData.last_name !== '' && formData.table_type !== '' && formData.table_value;

    const filterSummary = useMemo(() => {
        const prokirisiLabel = PROKIRIKSI_OPTIONS.find((option) => option.value === formData.table_type)?.label;
        const nameParts = [formData.last_name, formData.first_name].filter(Boolean).join(' ');
        return joinFilterSummaryParts([prokirisiLabel, nameParts]);
    }, [formData.table_type, formData.last_name, formData.first_name]);

    return (
        <div id="root">
            <Header handleLogout={handleLogout}/>
            <main className='main-container ranking-per-state-page'>
                <FilterSidebar
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                    filterSummary={filterSummary}
                    bodyId="ranking-personal-details-sidebar-body"
                >
                        <Form>
                    <Form.Group className="mb-3">
                        <Form.Label className='custom-label'>Προκήρυξη διαγωνισμού:</Form.Label>
                        <Form.Select className="custom-form" name="table_type" value={formData.table_type} onChange={handleChange} required>
                            <option value="">Επιλέξτε προκύρηξη διαγωνισμού</option>
                            <optgroup label="Τρέχουσες προκηρύξεις">
                                {PROKIRIKSI_OPTIONS.filter((option) => option.featured).map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option> ))}
                            </optgroup>
                            <optgroup label="Παλαιότερες προκηρύξεις">
                                {PROKIRIKSI_OPTIONS.filter((option) => !option.featured).map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option> ))}
                            </optgroup>
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label className='custom-label'>
                            Επώνυμο:
                        </Form.Label>
                        <Form.Control 
                            className="custom-form"
                            // style={{ textTransform: 'uppercase' }} 
                            type="text" 
                            name="last_name" 
                            value={formData.last_name} 
                            onChange={handleChange} 
                            required />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label className='custom-label'>
                            Όνομα <span className="text-danger" style={{ fontSize: '0.875rem' }}>(προαιρετικό πεδίο)</span>:
                        </Form.Label>
                        <Form.Control 
                            className="custom-form"
                            // style={{ textTransform: 'uppercase' }}
                            type="text" 
                            name="first_name" 
                            value={formData.first_name} 
                            onChange={handleChange} 
                            required />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label className='custom-label'>
                            Πατρώνυμο <span className="text-danger" style={{ fontSize: '0.875rem' }}>(προαιρετικό πεδίο)</span>:
                        </Form.Label>
                        <Form.Control 
                            className="custom-form" 
                            // style={{ textTransform: 'uppercase' }}
                            type="text" 
                            name="father_name" 
                            value={formData.father_name} 
                            onChange={handleChange} 
                            required />
                    </Form.Group>
                    {/* <Form.Group className="mb-3">
                        <Form.Label className='custom-label'>Α.Δ.Τ.:</Form.Label>
                        <Form.Control className="custom-form" type="text" name="id_card_number" value={formData.id_card_number} onChange={handleChange} required />
                    </Form.Group> */}
                    <Form.Group className="mb-3">
                        <Form.Label className='custom-label'>Είδος πίνακα:</Form.Label>
                        <Form.Select 
                            className="custom-form" 
                            name="table_value" 
                            value={formData.table_value} 
                            onChange={handleChange} 
                            required
                        >
                            <option value="">Επιλέξτε πίνακα</option>
                            {TABLE_OPTIONS.map((option) => {
                                const disabled = ["cleaned_aug26", "cleaned_sep26", "cleaned_oct26"].includes(option.value) &&
                                    TABLE_TYPES_WITHOUT_CLEANED_AUG26.includes(formData.table_type);
                                return (
                                    <option key={option.value} value={option.value} disabled={disabled}>
                                        {option.label}{disabled ? " (μη διαθέσιμος)" : ""}
                                    </option>
                                );
                            })}
                        </Form.Select>
                    </Form.Group>
                        </Form>
                        <p className="ranking-per-state-sidebar-note text-muted fst-italic small">
                            <u><b>Παρατηρήσεις</b></u><br/>
                            <ul>
                                <li>Οι εκκαθαρίσεις των πινάκων έχουν γίνει βάσει Επωνύμου, Ονόματος, Πατρωνύμου και Κλάδου. Πιθανή απόκλιση θέσης: 2% - 4%.</li>
                            </ul>
                        </p>
                        <div className="d-flex justify-content-center mb-4">
                            <Button
                                variant="secondary"
                                type="button"
                                className="predict-submit-button"
                                onClick={handleSubmit}
                                disabled={!isFormValid}
                            >
                                Εύρεση
                            </Button>
                        </div>
                </FilterSidebar>
                <div className={`ranking-per-state-main ${!sidebarOpen ? 'ranking-per-state-main--sidebar-collapsed' : ''}`}>
                    <Container fluid className="ranking-per-state-container">
                        <Row className="g-3 g-md-4">
                            <Col xs={12}>
                                <div className="ranking-per-state-content">
                                {!results && !loading && (
                                    <p className="text-muted small mb-2">
                                        Ο εκπαιδευτικός εισάγει τα παρακάτω στοιχεία:
                                <ul>
                                    <li><strong>Προκήρυξη διαγωνισμού:</strong> Η ονομασία του διαγωνισμού από τον οποίο προκύπτει ο πίνακας προσλήψεων (π.χ. 1ΓΕ/2023)</li>
                                    <li><strong>Επώνυμο</strong> (υποχρεωτικό πεδίο)</li>
                                    <li><strong>Όνομα</strong> (προαιρετικό πεδίο)</li>
                                    <li><strong>Πατρώνυμο</strong> (προαιρετικό πεδίο)</li>
                                    {/* <li><strong>Α.Δ.Τ.</strong> (προαιρετικό πεδίο): ο Α.Δ.Τ. που είναι δηλωμένος στην συγκεκριμένη προκήρυξη</li> */}
                                    <li><strong>Είδος πίνακα</strong>: Αρχικός πίνακας ή Εκκαθαρισμένος μετά τους τελευταίους διορισμούς</li>
                                </ul>
                                Το αποτέλεσμα της αναζήτησης είναι η θέση του εκπαιδευτικού στον πίνακα που έχει επιλέξει.
                                    </p>
                                )}
                                {loading && (
                                    <div className="text-center mt-3 mb-3">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <div>Φόρτωση αποτελεσμάτων...</div>
                                    </div>
                                )}

                                {results ? (
                                    <div className={!sidebarOpen ? 'results-snug-mobile' : ''}>
                                        {results.length > 0 ? (
                                            <>
                                                <h5 className='my-3'>Αποτελέσματα</h5>
                                                <div className="data-container">
                                                    {results.map((result, index) => (
                                                        <Card className='custom-card' key={index}>
                                                            <Card.Body>
                                                                <ListGroup className="list-group-flush">
                                                                    <ListGroup.Item>Επώνυμο: {result.last_name}</ListGroup.Item>
                                                                    <ListGroup.Item>Όνομα: {result.first_name}</ListGroup.Item>
                                                                    <ListGroup.Item>Πατρώνυμο: {result.father_name}</ListGroup.Item>
                                                                    <ListGroup.Item>Θέση πίνακα: {result.ranking}</ListGroup.Item>
                                                                    <ListGroup.Item>Ειδικότητα: {result.specialty}</ListGroup.Item>
                                                                    <ListGroup.Item>Μόρια: {result.grade}</ListGroup.Item>
                                                                </ListGroup>
                                                            </Card.Body>
                                                        </Card>
                                                    ))}
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <h5 className='my-3'>Αποτελέσματα</h5>
                                                <div className="data-container">
                                                    <Card className='custom-card'>
                                                        <Card.Body>
                                                            <Card.Title>Δεν υπάρχουν αποτελέσματα</Card.Title>
                                                        </Card.Body>
                                                    </Card>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                ) : !loading && null}
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </main>           
            <Footer />

            
        </div>

    );
}

export default RankingPersonalDetails;
